import { Instant } from "@js-joda/core";

export type Jwt = {
  token: string;
  expiration: string;
};

export const isTokenExpired = (token: Jwt) => {
  const expiration = Instant.parse(token.expiration);
  return Instant.now().isAfter(expiration);
};
